import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { DecorativeDivider } from './ui/DecorativeDivider';
export function PainPointSection() {
  return <section className="py-10 md:py-16 px-4 md:px-6 bg-navy-light" data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <FadeIn data-id="element-198">
          <h2 className="text-2xl md:text-4xl font-serif text-center mb-8 md:mb-12 text-gold" data-id="element-199">
            Si estás leyendo esto en la madrugada…
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6 text-base md:text-xl text-white/70 leading-relaxed font-sans" data-id="element-200">
          <FadeIn delay={0.1} data-id="element-201">
            <p data-id="element-202">…probablemente no es porque quieras.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-203">
            <p data-id="element-204">Es porque tu bebé se despertó otra vez.</p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-205">
            <p data-id="element-206">
              Y tú ya probaste de todo: cargar, mecer, pecho/biberón, chupete,
              ruido blanco, cambiar pañal, caminar por la casa…
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-207">
            <p data-id="element-208">
              y aun así, vuelves a la cama pensando:{' '}
              <span className="italic text-white/90" data-id="element-209">
                "¿Qué estoy haciendo mal?"
              </span>
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-210">
            <p className="mt-6 md:mt-10" data-id="element-211">Déjame decirte algo con claridad:</p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-212">
            <p className="text-xl md:text-3xl font-serif font-bold text-gold my-5 md:my-8 text-center" data-id="element-213">
              No estás fallando.
            </p>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-214">
            <p data-id="element-215">
              Estás agotada porque nadie te explicó el sueño de tu bebé de forma
              simple, práctica y aplicable.
            </p>
          </FadeIn>

          <FadeIn delay={0.8} data-id="element-216">
            <p className="font-medium text-white" data-id="element-217">
              Y eso es exactamente lo que vas a encontrar aquí.
            </p>
          </FadeIn>
        </div>

        <DecorativeDivider data-id="element-218" />
      </div>
    </section>;
}